import { MdOutlineSearch } from 'react-icons/md';
import styled from 'styled-components';

const SearchIcon = styled(MdOutlineSearch)`
  margin-left: 14px;
  margin-right: 8px;
`;

const StyledInput = styled.input`
  width: 100%;
  border: none;
  border: 1px;
  box-shadow: none;
  padding: 16px 8px 16px;
  outline: none;
  background-color: transparent;
  height: 40px;
  border-radius: 4px;
`;

const getWidth = (props) => {
  if (props.width) {
    return props.width;
  }
  if (props.main) {
    return '50%';
  }
  return '100%';
};

const getMargin = (props) => {
  if (props.margin) {
    return props.margin;
  }
  if (props.main) {
    return '0 0 20px 0';
  }
  return '0';
};

const Container = styled.div`
  width: ${getWidth};
  min-width: 200px;
  margin: ${getMargin};
  display: flex;
  flex-direction: ${(props) => (props.main ? 'column' : 'row')};
  align-items: ${(props) =>
    props.alignItems ? props.alignItems : 'flex-start'};
  justify-content: center;
  box-shadow: 0 0 0 0.5px ${({ theme }) => theme.COLOR_GREY5};
  font-size: 17px;
  align-items: center;
  justify-content: flex-start;
  border-width: 0px, 0px, 0px, 0px;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  border-radius: 4px;
  @media (max-width: 900px) {
    width: ${getWidth};
  }
`;

const Icon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.COLOR_GREY4};
  margin-left: 14px;
  margin-right: 8px;
`;

const StyledTableSearchInput = {
  Container,
  StyledInput,
  SearchIcon,
  Icon,
};

export default StyledTableSearchInput;
